var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MPInstancesHub } from "../RequestAxios/RequestAxiosHub";
import { unpackNotifications } from "./notification.mapper";
var getAllNotificationsURL = "/notifications/me";
var markNotificationAsReadURL = "/notifications/mark_as_read";
export var getNotifications = function (queryParams) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.notifications.get(getAllNotificationsURL, {
                    params: queryParams,
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, unpackNotifications(data)];
        }
    });
}); };
export var getAllNotifications = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.notifications.get(getAllNotificationsURL)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, unpackNotifications(data)];
        }
    });
}); };
export var markNotificationAsRead = function (ids) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.notifications.post(markNotificationAsReadURL, { notification_ids: ids })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data.data];
        }
    });
}); };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm90aWZpY2F0aW9ucy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5vdGlmaWNhdGlvbnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLGlDQUFpQyxDQUFDO0FBQ2pFLE9BQU8sRUFBRSxtQkFBbUIsRUFBRSxNQUFNLHVCQUF1QixDQUFDO0FBRTVELElBQU0sc0JBQXNCLEdBQUcsbUJBQW1CLENBQUM7QUFFbkQsSUFBTSx5QkFBeUIsR0FBRyw2QkFBNkIsQ0FBQztBQUVoRSxNQUFNLENBQUMsSUFBTSxnQkFBZ0IsR0FBRyxVQUFPLFdBSXRDOzs7O29CQUNrQixxQkFBTSxjQUFjLENBQUMsZUFBZSxDQUFDLGFBQWEsQ0FBQyxHQUFHLENBQ3JFLHNCQUFzQixFQUN0QjtvQkFDRSxNQUFNLEVBQUUsV0FBVztpQkFDcEIsQ0FDRixFQUFBOztnQkFMTyxJQUFJLEdBQUssQ0FBQSxTQUtoQixDQUFBLEtBTFc7Z0JBT1osc0JBQU8sbUJBQW1CLENBQUMsSUFBSSxDQUFDLEVBQUM7OztLQUNsQyxDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0sbUJBQW1CLEdBQUc7Ozs7b0JBQ2hCLHFCQUFNLGNBQWMsQ0FBQyxlQUFlLENBQUMsYUFBYSxDQUFDLEdBQUcsQ0FDckUsc0JBQXNCLENBQ3ZCLEVBQUE7O2dCQUZPLElBQUksR0FBSyxDQUFBLFNBRWhCLENBQUEsS0FGVztnQkFJWixzQkFBTyxtQkFBbUIsQ0FBQyxJQUFJLENBQUMsRUFBQzs7O0tBQ2xDLENBQUM7QUFFRixNQUFNLENBQUMsSUFBTSxzQkFBc0IsR0FBRyxVQUFPLEdBQWE7Ozs7b0JBQ3ZDLHFCQUFNLGNBQWMsQ0FBQyxlQUFlLENBQUMsYUFBYSxDQUFDLElBQUksQ0FDdEUseUJBQXlCLEVBQ3pCLEVBQUUsZ0JBQWdCLEVBQUUsR0FBRyxFQUFFLENBQzFCLEVBQUE7O2dCQUhPLElBQUksR0FBSyxDQUFBLFNBR2hCLENBQUEsS0FIVztnQkFLWixzQkFBTyxJQUFJLENBQUMsSUFBSSxFQUFDOzs7S0FDbEIsQ0FBQyJ9